export default __webpack_public_path__ + "static/media/Greaves of Red Ruin.e01dbaf4.jpg";